module.exports = __webpack_public_path__ + "img/haft-poznan-11.4cbd64eb.jpg";